import { render, staticRenderFns } from "./addPrase.vue?vue&type=template&id=06b53308"
import script from "./addPrase.vue?vue&type=script&lang=js"
export * from "./addPrase.vue?vue&type=script&lang=js"
import style0 from "./addPrase.vue?vue&type=style&index=0&id=06b53308&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports